import { action, makeObservable, observable } from 'mobx'
import { trackedAction } from 'mobx-async'
import { computedFn } from 'mobx-utils'

import { CustomFieldSectionProjection } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { CustomFieldProps } from '@new/__global/components/CustomField/_types'

import { getPropertyCustomFields } from '@arriere/modules/customFields'
import { CustomFieldsProjectionView } from '@arriere/types/CustomFields.types'
import {
  getCustomField,
  jsonParseCustomFieldValue,
  PROPERTY_TYPE_CUSTOM_FIELD_ID,
} from '@utils/customFields'

class _PropertyCustomFieldsStore {
  homeCustomFields?: CustomFieldsProjectionView[]

  constructor() {
    makeObservable(this, {
      homeCustomFields: observable,
      setHomeCustomFields: action.bound,
    })

    this.getHomeCustomFields = trackedAction<any>(this.getHomeCustomFields.bind(this))
  }

  setHomeCustomFields(customFields?: CustomFieldsProjectionView[]) {
    this.homeCustomFields = customFields
  }

  checkPropertyHotelType = computedFn((customFields?: CustomFieldSectionProjection[]) => {
    const propertyTypeCustomField = getCustomField({
      customFields: customFields || [],
      id: PROPERTY_TYPE_CUSTOM_FIELD_ID,
      type: 'fields',
    }) as CustomFieldProps

    return propertyTypeCustomField
      ? jsonParseCustomFieldValue(propertyTypeCustomField) === 'Hotel'
      : false
  })

  async getHomeCustomFields(homeId: string) {
    const homeCustomFields = await getPropertyCustomFields(homeId).then(data => data?.customFields)

    this.setHomeCustomFields(homeCustomFields)
  }
}

export const PropertyCustomFieldsStore = new _PropertyCustomFieldsStore()
